import axiosInstance from "./AxiosConfig";

class PaymentGatewayApi {
  async GetPaymentGateway() {
    try {
      const response = await axiosInstance.get("/razorPay/get");
      return response.data;
    } catch (error) {
      console.error(error);
      return {
        StatusCode: error?.response?.status,
        error:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.response?.data?.Message ||
          error?.message ||
          "Request failed",
        Result: error?.response?.data,
      };
    }
  }

  async SavePaymentGateway(value) {
    try {
      const response = await axiosInstance.post("/razorPay/create", { value });
      return response.data;
    } catch (error) {
      console.error(error);
      return {
        StatusCode: error?.response?.status,
        error:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.response?.data?.Message ||
          error?.message ||
          "Request failed",
        Result: error?.response?.data,
      };
    }
  }
}

export default new PaymentGatewayApi();
